import React, { ReactElement, StyleHTMLAttributes } from "react";
import path from "path";

interface ControlButtonProps {
  onClick: () => void;
  imgName: string;
  imgUrl?: string;
  alt?: string;
  className?: string;
  style?: StyleHTMLAttributes<HTMLElement> | {};
  text?: string;
  imageStyle?: StyleHTMLAttributes<HTMLElement> | {};
  textStyle?: StyleHTMLAttributes<HTMLElement> | {};
}

function ControlButton({
  onClick,
  imgName,
  imgUrl,
  alt = "",
  className,
  text,
  imageStyle,
  textStyle,
  ...props
}: ControlButtonProps): ReactElement {
  return (
    <button
      type={"button"}
      className={`${text ? "px-3" : ""} ${
        className ? className : `product-canvas__btn m-1`
      }`}
      onClick={onClick}
      {...props}>
      <img
        src={
          imgUrl ? imgUrl : path.resolve(`${window.basePath}/images/${imgName}`)
        }
        style={imageStyle}
        alt={alt}
      />
      {text && (
        <p
          style={{
            fontSize: 14,
            ...textStyle,
          }}
          className={"mb-0 ml-2 text-white"}>
          {text}
        </p>
      )}
    </button>
  );
}

export default ControlButton;
